import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var schedulingCalendarStyles = StyleSheet.create({
  iosDoneButton: {
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  actionCtaStyle: {
    paddingLeft: tokens.spacing.SPACING_36
  },
  openButton: {
    position: 'absolute',
    right: tokens.spacing.SPACING_4,
    top: tokens.spacing.SPACING_0,
    bottom: tokens.spacing.SPACING_0,
    pointerEvents: 'none'
  },
  calendarContainer: {
    position: 'relative'
  },
  calendarInput: {
    opacity: 0
  }
});